import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

type Props = {
  backgroundColor?: string;
};

const useStyles = createUseStyles({
  containerIcon: {
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50px",
    cursor: "pointer",
    backgroundColor: (props: Props) =>
      props.backgroundColor ? props.backgroundColor : colors.default,
  },
});

export default useStyles;
